<template>
  <div class="box">
    <div class="comment" v-for="(item, index) in list" :key="item.id">
      <div class="comment_avatar">
        <img :src="item.user_avatar" />
        <!-- 右上角的党徽 -->
        <img
          v-if="item.user_type === 2"
          class="party"
          src="http://img.wish.hebyun.com.cn/images/party.png"
        />
      </div>
      <div class="comment_right">
        <div class="list_funs">
          <div class="list_left">
            <span class="name">{{ item.user_nick }}：</span>
            <span class="time">{{ item.add_time }}</span>
          </div>
          <div class="list_right">
            <div
              class="list_right_item thumb"
              @click="handleThumb(item.id, index)"
            >
              <img
                :src="
                  item.is_thumb === 0
                    ? 'http://img.wish.hebyun.com.cn/images/thumb_comment.png'
                    : 'http://img.wish.hebyun.com.cn/images/thumb_active.png'
                "
              />
              <span
                v-if="item.prize_count > 0"
                :class="item.is_thumb === 0 ? '' : 'activePrize'"
                >{{ item.prize_count }}</span
              >
            </div>
            <div
              class="list_right_item replay_btn"
              @click="handleInput(item.id)"
            >
              <img
                src="http://img.wish.hebyun.com.cn/images/replay_comment.png"
              />
              <!-- <span>0</span> -->
            </div>
          </div>
        </div>
        <!-- 评论内容 -->
        <div class="list_text">{{ item.comment }}</div>
        <!-- 回复内容 -->
        <div class="reply_text" v-if="item.parent_commet !== null">
          <div class="reply_textList">
            <div>回复</div>
            <div style="margin-right:6px">@{{ item.parent_commet.nick }}：</div>
          </div>

          <div>{{ item.parent_commet.comment | ellipsis }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '25%' }">
      <div class="shuru">
        <van-field
          ref="content"
          v-model="comment"
          rows="3"
          autosize
          type="textarea"
          maxlength="120"
          placeholder="请发表你的留言"
          show-word-limit
        />
        <div class="fasong" @click="handleSubmit">发送</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ["list", "module", "id"],
  data() {
    return {
      showPopup: false,
      comment: "", //评论
    };
  },
  filters: {
    ellipsis(_val) {
      if (!_val) return "";
      if (_val.length > 20) {
        return _val.slice(0, 20) + "...";
      }
      return _val;
    },
  },
  created() {},
  methods: {
    // 点赞评论
    handleThumb(id, index) {
      if (this.isLogin()) {
        if (this.list[index].is_thumb === 0) {
          let data = {
            id: id,
          };
          this.$api.thumbComment(data);
          this.list[index].is_thumb = 1;
          this.list[index].prize_count += 1;
        } else {
          this.$api.error("请勿重复点赞");
        }
      } else {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },
    // 点击输入框，弹出输入弹框
    handleInput(id) {
      let that = this;
      if (that.isLogin()) {
        this.parentid = id;
        this.showPopup = true;
      }else{
          window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },
    // 点击发送
    async handleSubmit() {
      if (this.comment.trim().length === 0) {
        this.$toast("请输入内容");
        return;
      }
      let data = {
        module: this.module,
        id: this.id,
        comment: this.comment,
        parentid: this.parentid,
      };
      await this.$api.publishComment(data);
      this.$toast("发送成功,审核通过后可见");
      this.comment = "";
      this.showPopup = false;
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  .activePrize {
    color: #e60012 !important;
  }
  .comment {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    margin-bottom: 1px;
    .comment_avatar {
      position: relative;
      margin-right: 7px;
      margin-top: 10px;
      img {
        width: 31px;
        height: 31px;
        border-radius: 50%;
        object-fit: cover;
      }
      .party {
        position: absolute;
        right: 2px;
        top: -2px;
        width: 10px;
        height: 10px;
      }
    }
    .comment_right {
      flex: 1;
      text-align: left;
      width: 590px;
      .list_funs {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        margin-top: -10px;
        .list_left {
          display: flex;
          flex-direction: column;
          .name {
            font-size: 13px;
            font-weight: normal;
            line-height: 1;
            color: #333333;
            margin-bottom: 4.5px;
          }
          .time {
            font-size: 11px;
            font-weight: 400;
            letter-spacing: 0.5px;
            color: #999999;
          }
        }
        .list_right {
          display: flex;
          align-items: center;
          .list_right_item {
            display: flex;
            align-items: center;
            margin-left: 20px;
            span {
              font-size: 12px;
              font-weight: 400;
              letter-spacing: 0.5px;
              color: #999999;
              margin-left: 4px;
            }
          }

          .thumb {
            img {
              width: 12.5px;
              height: 11.5px;
            }
          }
          .replay_btn {
            img {
              width: 14px;
              height: 13.5px;
            }
          }
        }
      }
      /* 评论内容 */
      .list_text {
        font-size: 13px;
        line-height: 1;
        color: #666666;
        margin-bottom: 7.5px;
        margin-top: 12px;
      }
    }
    // 回复内容
    .reply_text {
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      background-color: #fffadc;
      border-radius: 5px;
      padding: 10px;
      // white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #666;
      .reply_textList {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  /deep/ .van-popup {
    z-index: 3000 !important;
  }
}
.shuru {
  width: 90%;
  margin: 10px auto;
  .fasong {
    width: 50px;
    height: 30px;
    line-height: 30px;
    background-color: #e60012;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    float: right;
    margin-top: 5px;
  }
  /deep/.van-cell {
    height: 100px;
    background-color: #e9e9e9;
    border-radius: 10px;
    padding: 10px;
    /deep/.van-field__control {
      height: 90px !important;
      font-size: 14px;
      line-height: 20px;
    }
    /deep/ .van-field__word-limit {
      font-size: 11px;
      margin-top: 0;
    }
  }
}
</style>
